const footer = {
  builtBy: 'Designed and built by',
  contact: 'Contact',
  references: 'Clients & references',
  sound: {
    on: 'Sound on',
    off: 'Sound off',
    enable: 'Turn interface sounds on',
    disable: 'Turn interface sounds off',
  },
};

export default footer;
